<template>
    <div>
        <div class="vld-parent" v-if="isLoading">
            <loading
                :active.sync="isLoading"
                :can-cancel="false"
                :is-full-page="true"
                loader="dots"
            ></loading>
        </div>
        <div v-if="!isShowDashboard">
            <CRow>
                <CCol sm="1"></CCol>
                <CCol sm="10">
                    <CCard class="topContainer">
                        <CCardBody class="cardBody">
                            <p class="headerText my-auto">
                                Let's get to know your company
                            </p>
                        </CCardBody>
                    </CCard>
                </CCol>
                <CCol sm="1"></CCol>
            </CRow>
            <CRow>
                <CCol sm="3"></CCol>
                <CCol sm="2">
                    <h5 :class="isAddress ? 'blueText' : 'whiteText'">
                        1. Organisation
                    </h5>
                    <hr :class="isAddress ? 'blueRuler' : 'whiteRuler'" />
                </CCol>
                <!-- <CCol sm="2">
                <h5 :class="isTax ? 'blueText' : 'whiteText'">
                    2. Tax setup
                </h5>
                <hr :class="isTax ? 'blueRuler' : 'whiteRuler'" />
            </CCol> -->
                <CCol sm="2">
                    <h5 :class="isAutomation ? 'blueText' : 'whiteText'">
                        2. Automation
                    </h5>
                    <hr :class="isAutomation ? 'blueRuler' : 'whiteRuler'" />
                </CCol>
                <CCol sm="3"></CCol>
            </CRow>
            <CRow v-if="isAddress">
                <CCol sm="3"></CCol>
                <CCol sm="6">
                    <CInput
                        label="Company Name"
                        :value.sync="companyName"
                        placeholder="Enter your company's name"
                        description="The name of the legal entity"
                        addInputClasses="DashboardDescription"
                    />
                    <CInput
                        label="Brand Name"
                        placeholder=""
                        :value.sync="brandName"
                        description="If your company is publicly known by a different brand name, then please enter that here."
                        addInputClasses="DashboardDescription"
                    />
                    <CInput
                        label="Wallet Address"
                        :value.sync="walletAddress"
                        placeholder="Please enter wallet address"
                    />
                    Select Country
                    <br /><br />
                    <select
                        class="selectClass"
                        @change="onCountryChange($event)"
                    >
                        <option disabled value="">Country</option>
                        <option>India</option>
                        <option>USA</option>
                    </select>
                    Location
                    <br /><br />
                    <select
                        class="selectClass"
                        @change="onLocationChange($event)"
                    >
                        <option disabled value="">Location</option>
                        <option>Registered company</option>
                        <option>Remote</option>
                        <option>DAO</option>
                    </select>
                    <CInput
                        v-if="isShowAddress"
                        label="Registered address"
                        :value.sync="registerAddress"
                        placeholder="Enter your work address"
                        description="If you have a GSTIN, then please provide the address mentioned on your GST certificate."
                        addInputClasses="DashboardDescription"
                    />
                    <CInput
                        v-if="isShowAddress"
                        label=""
                        :value.sync="registerAddress2"
                        placeholder="Address line 2"
                    />
                    <CInput
                        v-if="isShowAddress"
                        label="ZIP Code"
                        :value.sync="zipCode"
                        placeholder="Enter your ZIP Code"
                    />
                </CCol>
                <CCol sm="3"></CCol>
            </CRow>
            <!-- <CRow v-if="isTax">
            <CCol sm="3"></CCol>
            <CCol sm="6">
                <CInput
                    label="Company PAN"
                    placeholder="Enter your company PAN number"
                    description="You can verify your PAN here."
                    addInputClasses="DashboardDescription"
                />
                <CInput
                    label="Company TAN"
                    placeholder="Enter your company TAN number"
                    description="You can verify your TAN here."
                    addInputClasses="DashboardDescription"
                />
                <CInput
                    label="Company GSTIN"
                    placeholder="Enter your company GSTIN number"
                    description="Please enter a valid GSTIN if you want to claim GST credit on our invoices. Details."
                    addInputClasses="DashboardDescription"
                />
            </CCol>
            <CCol sm="3"></CCol>
        </CRow> -->
            <CRow v-if="isAutomation">
                <CCol sm="3"></CCol>
                <CCol sm="6">
                    <CInputCheckbox
                        id="checkbox"
                        class="checkBox"
                        :checked="isPayrollEnable"
                        label="Payroll Enabled"
                    />

                    <CCard class="cardWidget">
                        Choose when you would like to pay your employees. Select
                        a date after the 15th to pay your employees for the same
                        month eg. if you pick 31, then your employees will get
                        paid for January on 31st January. Or, if you pick 1,
                        then your employees will get paid for January on 1st
                        February.
                    </CCard>
                    Select the date of month<br /><br />
                    <select class="selectClass" @change="onDateChange($event)">
                        <option disabled value="">Please select the day</option>
                        <option v-for="no in 30" :key="no">{{ no }}</option>
                    </select>
                    <CCard class="cardWidget">
                        You can choose to either manually request execution each
                        month before the payroll is executed, or Raftel can
                        automatically execute your payroll on your chosen date.
                    </CCard>
                    <CInputCheckbox
                        id="checkbox"
                        class="checkBox"
                        :checked="isAutoplayEnable"
                        label="Automatically run payroll on selected date"
                    />
                    <CCard class="cardWidget">
                        Employees can request salary advances through Raftel. If
                        approved, the advance amount will be paid immediately
                        and automatically recovered from future payments to the
                        employees.
                    </CCard>
                    <CInputCheckbox
                        id="checkbox"
                        class="checkBox"
                        :checked="isSalaryAdvanceEnable"
                        label="Let employees request salary advances"
                    />
                </CCol>
                <CCol sm="3"></CCol>
            </CRow>
            <CRow class="bottomButton">
                <CCol sm="3"></CCol>
                <CButton
                    color="info"
                    size="sm"
                    class="buttonSize"
                    @click="selectedNext"
                >
                    CONTINUE
                </CButton>
                <CCol sm="4"></CCol>
            </CRow>
        </div>
        <div v-else>
            <CCol sm="10">
                <CRow class="displayFlex">
                    <h4>Employer Details</h4>
                    <span class="EditButton">Edit</span>
                </CRow>
            </CCol>
            <CCol>
                <CDataTable
                    :items="employeeDetails"
                    :fields="items"
                    :column-filter="false"
                    hover
                    pagination
                    addTableClasses="table table-borderless table-hover table-sm table-condensed table-class"
                    style="width: 85%"
                    class="mt-1"
                >
                </CDataTable>
            </CCol>

            <!-- <loading
                v-model:
                active="isShowAddress"
                :can-cancel="true"
                :on-cancel="onCancel"
                :is-full-page="fullPage"
            /> -->
        </div>
    </div>
</template>

<script>
import LineChart from './LineChart';
import { Line, mixins } from 'vue-chartjs';
import { storeData } from '../../store';
import * as database from '../../services/database-connectivity';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

const items = [
    { key: 'key', label: '' },
    { key: 'value', label: '' }
];
export default {
    created: async function() {
        if (
            storeData.companyDetails != null &&
            storeData.companyDetails.length > 0
        ) {
            this.employeeDetails = storeData.companyDetails;
            this.isShowDashboard = true;
        }
    },
    components: {
        LineChart,
        Line,
        Loading
    },
    data() {
        return {
            isTax: false,
            isAddress: true,
            isLoading: false,
            isPayrollEnable: false,
            isAutoplayEnable: false,
            isAutomation: false,
            isSalaryAdvanceEnable: false,
            isShowAddress: true,
            isShowDashboard: false,
            companyName: '',
            brandName: '',
            walletAddress: '',
            fullPage: true,
            registerAddress: '',
            registerAddress2: '',
            zipCode: '',
            items,
            location: '',
            country: '',
            selectedDate: '',
            employeeDetails: [],
            userEnteredDetails: {},
            onDateChange(e) {
                this.selectedDate = e.target.value;
            },
            onLocationChange(e) {
                this.location = e.target.value;
                if (e.target.value != 'Registered company') {
                    this.isShowAddress = false;
                } else {
                    this.isShowAddress = true;
                }
            },
            onCountryChange(e) {
                this.country = e.target.value;
            }
        };
    },
    methods: {
        async selectedNext() {
            if (this.isAddress) {
                this.isAddress = false;
                this.isLoading = true;
                setTimeout(() => {
                    this.isLoading = false;
                    this.isAutomation = true;
                }, 2000);
            } else {
                console.log('data', this.userEnteredDetails);
                this.isLoading = true;
                var response = await database.insertEmployer(
                    this.companyName,
                    this.brandName,
                    this.walletAddress,
                    this.registerAddress,
                    this.country,
                    this.registerAddress2,
                    this.zipCode,
                    this.selectedDate,
                    this.isAutoplayEnable,
                    this.isPayrollEnable,
                    this.isSalaryAdvanceEnable
                );
                this.isLoading = false;
                console.log('here is the response', response);
                if (!this.isShowAddress) {
                    this.employeeDetails.push(
                        { key: 'Company Name', value: this.companyName },
                        { key: 'Brand Name', value: this.brandName },
                        {
                            key: 'Select Country',
                            value: this.country == '' ? 'India' : this.country
                        },
                        {
                            key: 'Location',
                            value:
                                this.location == ''
                                    ? 'Registered company'
                                    : this.location
                        },
                        { key: 'Selected date', value: this.selectedDate }
                    );
                } else {
                    this.employeeDetails.push(
                        { key: 'Company Name', value: this.companyName },
                        { key: 'Brand Name', value: this.brandName },
                        {
                            key: 'Select Country',
                            value: this.country == '' ? 'India' : this.country
                        },
                        {
                            key: 'Location',
                            value:
                                this.location == ''
                                    ? 'Registered company'
                                    : this.location
                        },
                        {
                            key: 'Registered address',
                            value: this.registerAddress
                        },
                        { key: 'Address 2', value: this.registerAddress2 },
                        { key: 'ZIP Code', value: this.zipCode },
                        { key: 'Selected date', value: this.selectedDate }
                    );
                }
                storeData.companyDetails = this.employeeDetails;
                this.isAddress = false;
                this.isShowDashboard = true;
            }
        }
    }
};
</script>

<style scoped>
.topContainer {
    height: 120px;
    color: white;
    border: none;
    background-color: #272f51;
    font-size: 21px;
}
.cardWidget {
    padding: 20px;
    background-color: #272f51;
    border: none;
}
.cardBody {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
}
.selectClass {
    width: 100%;
    color: white;
    background-color: #272f51;
    padding: 10px;
    margin-bottom: 20px;
}
.headerText {
    font-size: 30px;
}
.bottomButton {
    height: 100px;
}
hr {
    height: 3px;
}
h5 {
    text-align: center;
}
.buttonSize {
    height: 50px;
    padding: 10px 40px;
    margin-left: 15px;
    padding-bottom: 10px;
    background-color: #5a99e8;
}
.whiteRuler {
    background-color: white;
}
.blueRuler {
    background-color: #5a99e8;
}
.blueText {
    color: #5a99e8;
    text-align: center;
}
.whiteText {
    color: white;
    text-align: center;
}
.displayFlex {
    display: flex;
    justify-content: space-between;
    padding-left: 15px;
}
.EditButton {
    font-size: 20px;
    color: #5a99e8;
    align-content: center;
    cursor: pointer;
}
.checkBox {
    padding: 10px;
    padding-bottom: 20px;
}
</style>
